import _ from 'lodash';
import Link from '../domains/link.domain';
import { get } from './core/fetch';

export const getFooterLinks = (footerLinks: any): Array<Link> =>
	_(footerLinks.subpages)
		.map(key => {
			return _.flatten(_.toPairs(key))[1];
		})
		.filter((item: any) => !item.hideInNav)
		// @ts-ignore
		.map((item: any) => {
			return {
				url: item.pageurl,
				openInNewTab: newTabLink(item),
				title: item['jcr:title'],
			} as Link;
		})
		.value();

export const getNavigationFooterLinks = async () => {
	try {
		const params =
			'tidy=true&treenest=true&dumpproperties=pageRoute,pageurl,jcr:title,redirectTarget,hideInNav&ignoreproperties=sling:resourceType,jcr:created';
		const navUrl = `/secure/adviser/nav_footer.nabfeed.content.2.json?${params}`;
		const data = await get(navUrl, { withAuth: true });
		return getFooterLinks(data);
	} catch (e) {
		return [];
	}
};

export const newTabLink = (item: any): boolean => {
	const title = item['jcr:title'].toUpperCase();
	return title.indexOf('MEDIA') > -1 || title.indexOf('PRIVACY') > -1;
};
